// @ts-nocheck
'use strict';

var Swo = require('swiper/bundle');
var prodSwiper;

module.exports = {
    mySwiper: function () {
        prodSwiper = new Swo.Swiper('.product-list-carousel', {
            direction: 'horizontal',
            slidesPerView: '2',
            spaceBetween: 10,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            freeMode: true,
            preloadImages: false,
            watchSlidesVisibility: false
        });
    },
    getProdSwiper: function () {
        return prodSwiper;
    }
};
